<!--給与照会-->
<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;">
      <!--テーブル-->
      <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <!--検索-->
        <div class="search-module-k">
          <el-row style="padding-top:5px;padding-left:5px" :gutter="20">
            <!--年-->
            <el-col :span="8">
              <el-date-picker class="year_select" v-model="yearOpt" type="year" value-format="yyyy" @change="changeYear" size="mini" :clearable="false" :editable="false"></el-date-picker>
            </el-col>
            <!--前年 按钮-->
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;">
              <div>
                <el-button type="primary" id="last_year" class="css-button_p0001 css-btn_p0001" @click="handleClickLastYear" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click.stop="query_btn_l">{{$t('MODULE.P0001_LBL_LASTYEAR')}}</el-button>
              </div>
            </el-col>
            <!--翌年 按钮-->
            <el-col :span="6" style="padding-left: 10px; padding-right: 10px;">
              <div>
                <el-button type="primary" id="next_year" class="css-button_p0001 css-btn_p0001" @click="handleClickNextYear" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click.stop="query_btn_n">{{$t('MODULE.P0001_LBL_NEXTYEAR')}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 3px;padding-bottom: 5px;"></div>
        <el-table style="border: 0px solid #AAAAAA" :header-cell-style="p0001HeaderStyle" :cell-style="p0001IsCellStyle" :data="list" border @row-click="p0001RowOnClick" size="mini">
          <!--显示列-->
          <!--月-->
          <el-table-column fixed="left" :label="$t('MODULE.P0001_LBL_COLUMN1')" min-width="40px" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.paidDate.substring(scope.row.paidDate.indexOf('-')+1,scope.row.paidDate.length-3) + "月"}}</div>
            </template>
          </el-table-column>
          <!--種類-->
          <el-table-column fixed="left" :label="$t('MODULE.P0001_LBL_COLUMN2')" min-width="50px" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.type}}</div>
            </template>
          </el-table-column>
          <!--確認日時-->
          <el-table-column fixed="left" :label="$t('MODULE.P0001_LBL_COLUMN3')" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.confirmDate.substring(0, 16).replace(new RegExp("-",'g'),"/")}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import * as amsApi from "../api/p_0001"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  mixins: [css],
  data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      list: [],
      fullscreenLoading: false,
      yearOpt: ''
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 初期化
    this.init()
    // 期間より検索
    this.query()
  },
  mounted() {
  },
  methods: {
    // 初期化
    init() {
      if (!(JSON.stringify(this.$route.query) == "{}")) {
        this.yearOpt = JSON.parse(localStorage.getItem('P0001search_condition'));
      } else {
        var dt = new Date();
        this.yearOpt = dt.getFullYear().toString();
      }
      localStorage.setItem("P0001search_condition", JSON.stringify(this.yearOpt));
    },

    query_btn_l(e) {
      let target = e.target;
      target.blur();
      this.yearOpt = (parseInt(this.yearOpt) - 1).toString();
      localStorage.setItem("P0001search_condition", JSON.stringify(this.yearOpt));
      this.query()
    },
    query_btn_n(e) {
      let target = e.target;
      target.blur();
      this.yearOpt = (parseInt(this.yearOpt) + 1).toString();
      localStorage.setItem("P0001search_condition", JSON.stringify(this.yearOpt));
      this.query()
    },
    changeYear() {
      localStorage.setItem("P0001search_condition", JSON.stringify(this.yearOpt))
      this.query()
    },
    // 検索
    query() {
      var params = {
        year: this.yearOpt,
        userCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      // 検索処理
      amsApi.p_0001(params).then(res => {

        if (res.code == 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          this.list = []
        } else if (res.code == 204) {

          this.list = res.items.paymentStatusSet;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].confirmDate == null || this.list[i].confirmDate == "") {
              this.list[i].confirmDate = "";
            }
          }
        }
        loading.close();
      }).catch((error) => {
        loading.close();
      });
    },
    // TABLEHeader样式
    p0001HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center '
    },
    // TABLE单元格样式
    p0001IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;fontSize:13px'
    },
    // 单击行事件
    p0001RowOnClick(thisRowDate, column, cell, event) {
      if (thisRowDate.type == this.$t('MODULE.P0001_LBL_SALARY')) {
        //給与
        localStorage.setItem('obj', JSON.stringify(thisRowDate));
        localStorage.setItem(url.routerUrl_P0002, JSON.stringify(true));
        this.$router.push({ path: url.routerUrl_P0002 });
      } else if (thisRowDate.type == this.$t('MODULE.P0001_LBL_BONUS')) {
        //賞与
        localStorage.setItem('obj', JSON.stringify(thisRowDate));
        localStorage.setItem(url.routerUrl_P0003, JSON.stringify(true));
        this.$router.push({ path: url.routerUrl_P0003 });
      } else if (thisRowDate.type == this.$t('MODULE.P0001_LBL_SOURCE')) {
        //源泉
        localStorage.setItem('obj', JSON.stringify(thisRowDate));
        localStorage.setItem(url.routerUrl_P0004, JSON.stringify(true));
        this.$router.push({ path: url.routerUrl_P0004 });
      }
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },
    //前年按钮按下
    handleClickLastYear(e) {
      let target = e.target;
      target.blur();
    },
    //翌年按钮按下
    handleClickNextYear(e) {
      let target = e.target;
      target.blur();
    },
  },
}

</script>
<style scope>
/*ボタン*/
.css-button_p0001 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 13px;
}
/*按钮经过样式*/
.css-btn_p0001:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_p0001:active,
.css-btn_p0001:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.css-btn_p0001.is-disabled,
.css-btn_p0001.is-disabled:focus,
.css-btn_p0001.is-disabled:hover {
  background-image: linear-gradient(#5bd3ff, #5bd3ff);
  color: #ffffff;
}

.year_select .el-input__inner {
  width: 100px;
}
.year_select.el-date-editor.el-input {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/p_0001.vue